import React, {useState, useEffect} from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa'
import Modal from 'react-bootstrap/Modal';
import { FormCad } from '../../../components';
import Swal from 'sweetalert2';
import initialData from '../../../Create/initialData';
import schema from '../../../Create/schema';
import { useDispatch, useSelector } from 'react-redux';
import { loadSubMenus, storeMenu } from '~/store/modules/menu/action';

const Create = () => {
  let history = useHistory();
  const { menu_id } = useParams();
  const [menu, setMenu] = useState(initialData);
  const [saved, setSaved] = useState(false);
  const [errorsValidate, setErrorsValidate] = useState([]);
  const dispatch = useDispatch();
  const { status_response, errors } = useSelector(({ MenuReducer }) => MenuReducer);

  useEffect(() => {
    if (errors.status && errors.status === 422) {
      let server_errors = {};
      const response_errors = errors.data.errors;
      for (let name of Object.keys(response_errors)) {
        Object.assign(server_errors, { [name]: response_errors[name][0] });
      }
      setErrorsValidate(server_errors);
    }
    if(errors.save) {
      setSaved(errors.save);
    }
  }, [errors]);
  useEffect(() => {

  },[])

  useEffect(() => {
    if (saved && status_response === 201) {
      Swal.fire('Sucesso', 'Sub menu criado com sucesso!', 'success').then(
        () => {
          history.push(`/menu/${menu_id}/detalhe`);
          dispatch(loadSubMenus(menu_id))
        }
      );
    }
  }, [status_response, history, dispatch, menu_id, saved]);


  const handleClose = () => {
    history.push(`/menu/${menu_id}/detalhe`);
    dispatch(loadSubMenus(menu_id));
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!schema.isValidSync(menu)) {
      let yup_errors = {};
      schema.validate(menu, { abortEarly: false }).catch(err => {
        for (let error of err.inner) {
          const { path, message } = error;
          Object.assign(yup_errors, { [path]: message });
        }
        setErrorsValidate(yup_errors);
      });
    } else {
      menu.menu_pai_id = menu_id;
      menu.menu_pai = false;
      await dispatch(storeMenu(menu));
    }
  };
  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      dialogClassName="modal-xl"
      onHide={handleClose}
      show
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">  Sub menu</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="card">
          <div className="card-header">
            <h2 className="card-title"> <FaPlus/> Novo</h2>
          </div>
          <div className="card-body">
            <FormCad
              errors={errorsValidate}
              handleSubmit={handleSubmit}
              menu={menu}
              schema={schema}
              setMenu={setMenu}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Link
          className="btn btn-default"
          to={`/menu/${menu_id}/detalhe`}
        >
          <i className="fa fa-window-close" /> Cancelar
        </Link>
        <button
          className="btn btn-success"
          form="form_menu"
          type="submint"
        > <i className="fa fa-save" /> Salvar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default Create;
